import constants from '../constants';
import authAxios from '../authorization/axios';

export class LocationsService {

  async getLocationsByEmail(mail: string) {
    const result = await authAxios.get(`${constants.api.getLocationsByContact}${encodeURIComponent(mail)}`);
    return result.data?.data;
  }

}